export default __webpack_public_path__ + "static/media/photo--lg--matt.dae9dab2.jpg";